var path = '/contactUs/contactUs.tpl.html';
var html = "<div class=contact-us> <div class=\"row ifds-right-heading\"> <div class=\"\"> <div class=ifds-right-title> <div> <h1> <span> {{contactUsController.contactUsTitle}} </span> </h1> </div> </div> </div> </div> <div class=\"row padding-4 margin-top-15\"> <div class=ifds-main-content ng-class=normal ng-bind-html=\"contactUsController.contactUsContent | sceTrustAsHtml\"> </div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./WebContent/src/contactUs/contactUs.tpl.html
// module id = 739
// module chunks = 0 2